import { useEffect, useState } from 'react';
import {
    Box, Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Paper, Select, MenuItem, Typography
} from '@mui/material';
import Header from '../../components/Header';
import { support } from "../../services/support.js";
import styles from './supportStyles';
import { useSnackbar } from "notistack";

const levels = ['ALL', 'TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'OFF'];

function Support() {
    const { enqueueSnackbar } = useSnackbar();
    const [logs, setLogs] = useState([]);
    const [serverLogs, setServerLogs] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');

    const getAllLoggers = async () => {
        try {
            const res = await support.getAllLoggers();
            setLogs(res);
        } catch (error) {
            enqueueSnackbar("Error al obtener loggers", {
                preventDuplicate: true,
                variant: "error"
            });
        }
    };

    const handleChangeLevel = (logId, newLevel) => {
        setLogs(prevLogs =>
            prevLogs.map(log =>
                log.id === logId ? { ...log, level: newLevel } : log
            )
        );
    };

    const downloadFile = (data, fileName) => {
        const blob = new Blob([data], { type: 'application/zip' });
        const href = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    };

    const downloadActiveLogs = async () => {
        try {
            const response = await support.downloadActiveLogs();
            downloadFile(response.data, 'active_logs.zip');
        } catch (error) {
            enqueueSnackbar("Error al descargar logs activos", {
                preventDuplicate: true,
                variant: "error"
            });
        }
    };

    const downloadAllLogs = async () => {
        try {
            const response = await support.downloadAllLogs();
            downloadFile(response.data, 'all_logs.zip');
        } catch (error) {
            enqueueSnackbar("Error al descargar todos los logs", {
                preventDuplicate: true,
                variant: "error"
            });
        }
    };

    const downloadLogsByDay = async () => {
        try {
            const response = await support.downloadLogsByDay(selectedDate);
            downloadFile(response.data, 'logs_' + selectedDate + '.zip');
        } catch (error) {
            enqueueSnackbar("Error al descargar logs del dia " + selectedDate, {
                preventDuplicate: true,
                variant: "error"
            });
        }
    };


    const updateLogs = async (log) => {
        try {
            await support.setLogLevel(log.name, log.level);
            enqueueSnackbar("Nivel de Logger actualizado", {
                preventDuplicate: true,
                variant: "success"
            });
        } catch (error) {
            enqueueSnackbar("Error al actualizar el nivel de Logger", {
                preventDuplicate: true,
                variant: "error"
            });
        }
    };

    useEffect(() => {
        getAllLoggers();
    }, []);

    return (
        <Box>
            <Header style={styles.header} title="LOGS" subtitle="Control de logs" />
            <Box style={styles.container}>
                <Box style={styles.buttonContainer}>
                    <Box>
                        <Button
                            style={selectedDate ? styles.button : styles.disabledButton}
                            disabled={!selectedDate}
                            onClick={downloadLogsByDay}
                        >
                            Descargar logs del día seleccionado
                        </Button>
                        <Button style={styles.button} onClick={downloadAllLogs}>Descargar todos los logs</Button>
                        <Button style={styles.button} onClick={downloadActiveLogs}>Descargar logs activos</Button>
                    </Box>
                    <TextField
                        sx={styles.datePicker}
                        label="Seleccionar fecha"
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                    />
                </Box>
                <Typography variant="h6" gutterBottom>Logs de Aplicación</Typography>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nombre</TableCell>
                                <TableCell>Nivel de Log</TableCell>
                                <TableCell>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logs.map((log) => (
                                <TableRow key={log.id}>
                                    <TableCell>{log.name}</TableCell>
                                    <TableCell>
                                        <Select
                                            value={log.level}
                                            sx={styles.select}
                                            onChange={(e) => handleChangeLevel(log.id, e.target.value)}
                                        >
                                            {levels.map((level) => (
                                                <MenuItem key={level} value={level}>
                                                    {level}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            title="Change Level"
                                            onClick={() => updateLogs(log)}
                                        >
                                            Cambiar Nivel
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}

export default Support;
